export const formatedColor = (clr = '') => {
  if (clr.includes(',')) {
    return `rgba(${clr})`;
  } else if (clr.length === 3 || clr.length === 6) {
    const regFull = /[a-f0-9]{6}\b/gi;
    const regMin = /[a-f0-9]{3}\b/gi;

    if (clr.length === 3 && regMin.test(clr)) {
      return `#${clr}`;
    } else if (clr.length === 6 && regFull.test(clr)) {
      return `#${clr}`;
    } else return clr;
  } else {
    return clr;
  }
};
